import React,{useEffect} from 'react';
import { useNavigate} from 'react-router-dom';
import CommonIn from '../utils/CommonIn';

const Business = () => {
  const navigate = useNavigate();

  const navigateToContract = () => {
    navigate("/contract");
  };
  
  useEffect(() => {
    // Code to execute after the component is mounted
    CommonIn();
  }, []); // Empty dependency array ensures this runs only once after initial render
  

  return (
    <>
      <main className="submain" id="submain">
        <div className="sub_header">
          <div className="container sub_header_inner">
            <h1>사업영역</h1>
          </div>
        </div>
        <div className="submenu">
          <div className="container">
            <div className="submenu_inner">
              <ul>
                <li><a href="#bsn_circul">유통</a></li>
                <li><a href="#bsn_medical">의료</a></li>
                <li><a href="#bsn_edu">교육</a></li>
                <li><a href="#bsn_erect">건설</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* 유통 섹션 */}
        <section className="bsn_wrap snlink" id="bsn_circul">
          <div className="container">
            <div className="bsn_content01">
              <div className="bsn_visual_text">
                <h2>"스마트 유통의 인재 운영, 우리가 만듭니다"</h2>
                <p>유통 산업 특성에 최적화된 인력관리 시스템으로, 근무 효율성, 인건비 절감, 인재 유지를 동시에 실현합니다.</p>
              </div>
              <div className="bsn_content_bg">
                <div className="bsn_tit">유통</div>
                <p className="bsn_bg_txt">유통 현장의 빠르고 유연한 인력 운영을 위한 HR 솔루션을 제공합니다.<br />매장 스케줄 자동화, 시급제 급여 연동, 직원 성과 관리 등<br />복잡한 인력 운영을 손쉽게 통합 관리할 수 있습니다.</p>
                <div className="bsn_bg_overlay"></div>
              </div>
              <div className="bsn_content_box bsn_content_txt">
                <div className="bsn_content_icon_wrap">
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content01_icon01.png" alt="모니터링 지원" /></div>
                    <p className="tit">모니터링 지원</p>
                    <p>PC/태블릿 기반<br />근로 현황 모니터링 지원</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content01_icon02.png" alt="근무 관리" /></div>
                    <p className="tit">근무 관리</p>
                    <p>일용직 근무 비율이<br />높은 현장 효율 관리 지원</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content01_icon03.png" alt="급여 계산" /></div>
                    <p className="tit">급여 계산</p>
                    <p>급여 자동화 및 준수 관리</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content01_icon04.png" alt="계약 관리" /></div>
                    <p className="tit">계약 관리</p>
                    <p>계약 관리 및 리스크 대응</p>
                  </div>
                </div>
              </div>
              {/* <!--도입사례--> */}
              <div className="case_chat_wrap">
                <div className="case_chat_tit">
                  <div className="chat_txt01">FACEONE 모바일 서비스 도입 전후 인터뷰</div>
                  <div className="chat_txt02">OO택배 인사관리팀 김성훈 팀장님</div>
                </div>
                <div className="case_chat_box">
                  <div className="column gray">
                    <div className="title">도입 전</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon01.png" alt=""/></div>"외부 인력 출입 관리와 안전 통제의 어려움"</div>
                    <div className="chat user"><div className="bubble gray">FACEONE 모바일 서비스를 도입하기 전, 어떤 점이 가장 불편하셨나요?</div></div>
                    <div className="chat response"><div className="bubble gray">건설 현장에 매일 수십 명의 외부 인력이 작업현장에서 직접 등록됩니다. 기존에는 수기로 출입 명부를 작성하거나, 간단한 QR 인증을 사용했는데, 대리 출입이나 기록 누락이 자주 발생했어요. 특히 안전 교육 이수 여부나 출입 시간 확인이 어려워 사고 예방에 한계가 있었어요.</div></div>
                    <div className="chat user"><div className="bubble gray">기존 시스템의 한계는 무엇이었나요?</div></div>
                    <div className="chat response"><div className="bubble gray">출입 기록이 실시간으로 확인되지 않아, 현장 내 인원 파악이 늦어졌고, 비상 상황 시 대피 인원 확인도 어렵겠더라고요. 또한, 외부 인력의 신원 확인이 제대로 되지 않아 보안 사고 위험도 있었습니다.</div></div>
                  </div>
                  <div className="column blue">
                    <div className="title">도입 후</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon02.png" alt=""/></div>"얼굴 인식 기반 출입 관리로 안전과 효율 향상"</div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 도입하고 나서 가장 크게 달라진 점은 무엇인가요?</div></div>
                    <div className="chat response"><div className="bubble blue">이제는 현장에 들어오는 모든 인력이 얼굴 인식으로 출입을 인증합니다. 사전 등록한 한번의 모바일 앱 등록만으로 출입 기록이 남고, 관리자 입장에선 실시간으로 인원 현황을 확인할 수 있어요. 특히 안전 교육 이수 여부도 연동되어, 미이수자는 출입이 제한됩니다.</div></div>
                    <div className="chat user"><div clasNames="bubble blue">현장 인력들의 반응은 어떤가요?</div></div>
                    <div className="chat response"><div className="bubble blue">처음엔 생소했지만, 지금은 “카드나 명부 없이 얼굴만 인식하면 되니 훨씬 편하다”는 반응이 많습니다. 출입 속도도 빨라지고, 대기 시간이 줄어들어 작업 시작이 더 원활해졌어요. 관리자 입장에서도 인증 통제가 훨씬 쉬워졌습니다.</div></div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 고민하는 다른 건설사에 한 말씀 해주신다면?</div></div>
                    <div className="chat response"><div className="bubble blue">건설 현장은 안전이 최우선입니다. FACEONE은 단순히 출입 인증을 넘어서, 실시간 인력 관리와 안전 통제까지 가능하게 해주는 스마트 솔루션입니다. 특히 외부 인력이 많은 현장이라면 꼭 도입해보시길 추천드립니다.</div></div>
                  </div>
                </div>
              </div>  
              {/* <!--//도입사례--> */}
            </div>
          </div>
        </section>

        {/* <!--의료--> */}
        <section className="bsn_wrap snlink" id="bsn_medical">
          <div className="container">
            <div className="bsn_content02">
              <div className="bsn_visual_text">
                <h2>"병원 인사와 출입통제를 하나로, 안전하고 편리하게"</h2>
                <p>교대근무·자격관리·교육 이수 관리는 기본, 생체인식 출입 인증과 환자 바코드 연계까지 통합된 병원 맞춤형 인력관리 시스템을 제공합니다.</p>
              </div>
              <div className="bsn_content_bg">
                <div className="bsn_tit">의료</div>
                <p className="bsn_bg_txt">정확한 교대근무 운영과 자격관리, 생체기반 출입 통제를 하나로 통합했습니다.<br/>환자 바코드 인증부터 직군별 출입 정책까지 병원에 최적화된 시스템을 제공합니다.<br/>안전하고 효율적인 의료 환경 구축을 지원합니다.</p>
                <div className="bsn_bg_overlay"></div>
              </div>
              <div className="bsn_content_box bsn_content_txt">
                <div className="bsn_content_icon_wrap">
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content02_icon01.png" alt=""/></div>
                    <p className="tit">생체인식 기반<br/>편리한 직원 출입인증</p>
                    <p>직원의 출입을 지문/안면 등<br/>생체 방식으로 자동 인증</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content02_icon02.png" alt=""/></div>
                    <p className="tit">입원환자 바코드 연동</p>
                    <p>환자 출입 시 바코드<br/>기반 인증으로 보안성 강화</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content02_icon03.png" alt=""/></div>
                    <p className="tit">출입자 유형별 출입 정책</p>
                    <p>간호사, 청소직, 외부 인력 등<br/>역할별 출입 권한 설정</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content02_icon04.png" alt=""/></div>
                    <p className="tit">교대근무표 자동 생성</p>
                    <p>근무 스케줄 생성 및<br/>교대 근무 자동 조정</p>
                  </div>
                </div>
              </div>
              {/* <!--도입사례--> */}
              <div className="case_chat_wrap">
                <div className="case_chat_tit">
                  <div className="chat_txt01">FACEONE 모바일 서비스 도입 전후 인터뷰</div>
                  <div className="chat_txt02">OO병원 시설관리팀 이지은 과장님</div>
                </div>
                <div className="case_chat_box med">
                  <div className="column gray">
                    <div className="title">도입 전</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon03.png" alt=""/></div>복잡한 출입 절차와 감염 관리의 어려움</div>
                    <div className="chat user"><div className="bubble gray">FACEONE 모바일 서비스를 도입하기 전, 어떤 점이 가장 불편하셨나요?</div></div>
                    <div className="chat response"><div className="bubble gray">병원은 환자, 보호자, 의료진, 외부 인력 등 다양한 사람들이 출입하는 공간입니다. 기존에는 출입증 발급이나 QR코드 인증 방식으로 관리했는데, 발급 절차가 번거롭고 감염 예방을 위한 비접촉 인증이 어려웠어요. 특히 응급 상황이나 야간 출입 시에는 보안이 취약해지는 문제가 있었습니다.</div></div>
                    <div className="chat user"><div className="bubble gray">기존 시스템의 한계는 무엇이었나요?</div></div>
                    <div className="chat response"><div className="bubble gray">출입 기록이 실시간으로 확인되지 않아, 감염병 발생 시 동선 추적이 늦어졌습니다. 외부 인력의 신원 확인도 수기로 진행되다 보니 오류가 많았고, 환자 보호자 출입 통제도 어려웠습니다.</div></div>
                  </div>

                  <div className="column blue">
                    <div className="title">도입 후</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon04.png" alt=""/></div>비접촉 얼굴 인증으로 보안과 감염 예방 강화</div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 도입하고 나서 가장 크게 달라진 점은 무엇인가요?</div></div>
                    <div className="chat response"><div className="bubble blue">얼굴 인식 기반 모바일 출입 시스템으로 바뀌면서, 출입 절차가 간소화되고 비접촉 인증이 가능해졌습니다. 의료진은 앱을 통해 자동으로 출입 기록이 남고, 외부 방문자는 사전 등록 후 얼굴 인증만으로 출입이 가능해졌어요. 감염 예방과 보안 측면에서 모두 큰 개선이 있었습니다.</div></div>
                    <div className="chat user"><div className="bubble blue">직원들과 방문자들의 반응은 어떤가요?</div></div>
                    <div className="chat response"><div className="bubble blue">의료진은 출퇴근 기록이 자동으로 연동되어 편리하다고 하고, 외부 인력도 별도 출입증 없이 얼굴만 인식하면 되니 만족도가 높습니다. 특히 보호자 출입 통제와 동선 관리가 쉬워져, 감염병 대응에도 도움이 되고 있어요.</div></div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 고민하는 다른 병원에 한 말씀 해주신다면?</div></div>
                    <div className="chat response"><div className="bubble blue">병원처럼 민감한 공간에서는 출입 관리가 곧 환자 안전과 직결됩니다. FACEONE은 단순한 인증 시스템을 넘어, 병원의 운영 효율성과 감염 예방까지 고려한 스마트 솔루션이라고 생각합니다.</div></div>
                  </div>
                </div>
              </div>  
              {/* <!--//도입사례--> */}
            </div>
          </div>  
        </section>
        {/* <!--//의료-->
        <!--교육--> */}
        <section className="bsn_wrap snlink" id="bsn_edu">
          <div className="container">
            <div className="bsn_content03">
              <div className="bsn_visual_text">
                <h2>"스마트한 출결, 정밀한 인사관리"</h2>
                <p>생체 기반 출결 인증과 보안 기술을 적용한 HR 시스템으로 교육기관의 출결관리, 부정출석 방지, 발열 확인까지 자동화합니다.</p>
              </div>
              <div className="bsn_content_bg">
                <div className="bsn_tit">교육</div>
                <p className="bsn_bg_txt">생체인식 기반 3D 인증 기술로 빠르고 정확한 출결이 가능합니다.<br/>RGB+IR 카메라와 발열 감지 연계로 부정 인증과 위생까지 철저히 관리합니다.<br/>스마트 출결로 안전하고 신뢰도 높은 교육환경을 만듭니다.</p>
                <div className="bsn_bg_overlay"></div>
              </div>
              <div className="bsn_content_box bsn_content_txt">
                <div className="bsn_content_icon_wrap">
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content03_icon01.png" alt="생체 기반 출결 인증"/></div>
                    <p className="tit">생체 기반 출결 인증</p>
                    <p>얼굴 인식 기반 자동 출결 처리,<br/>비접촉 방식</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content03_icon02.png" alt="부정 인증 방지 기술"/></div>
                    <p className="tit">부정 인증 방지 기술</p>
                    <p>타인 사진 인증 방지용<br/>RGB+IR 3D 얼굴 인식</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content03_icon03.png" alt="발열 측정 연동 출결"/></div>
                    <p className="tit">발열 측정 연동 출결</p>
                    <p>고열 감지 시 자동 알림 및 출결 차단</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content03_icon04.png" alt="IR LED 반사 감지"/></div>
                    <p className="tit">IR LED 반사 감지</p>
                    <p>실제 인물 여부를 빛 반사로<br/>판별해 인증 위조 차단</p>
                  </div>
                </div>
              </div>
              {/* <!--도입사례--> */}
              <div className="case_chat_wrap">
                <div className="case_chat_tit">
                  <div className="chat_txt01">FACEONE 모바일 서비스 도입 전후 인터뷰</div>
                  <div className="chat_txt02">OO어학원 원장 박지현 원장님</div>
                </div>
                <div className="case_chat_box aca">
                  <div className="column gray">
                    <div className="title">도입 전</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon05.png" alt=""/></div>수기 출결과 학부모 문의 대응의 어려움</div>
                    <div className="chat user"><div className="bubble gray">FACEONE 모바일 서비스를 도입하기 전, 어떤 점이 가장 불편하셨나요?</div></div>
                    <div className="chat response"><div className="bubble gray">저희 학원은 초등부터 고등학생까지 다양한 연령대의 학생들이 다니고 있어요. 기존에는 수기로 출결을 체크하거나, 학생증을 태그하는 방식이었는데, 종종 누락되거나
                      대리 출석 문제가 발생했죠. 학부모님들께서 "우리 아이 오늘 학원 왔나요?"라고 문의하실 떄 마다 일일이 확인해야 했고요.</div></div>
                    <div className="chat user"><div class="bubble gray">기존 시스템의 한계는 무엇이었나요?</div></div>
                    <div className="chat response"><div class="bubble gray">출결 정보가 실시간으로 공유되지 않다 보니, 학부모와의 소통에 시간이 걸렸고, 학생 안전 관리에도 한계가 있었어요. 특히 저학년 학생들은 
                      카드나 태그를 자주 잃어버려서 출결 관리가 더 어려웠습니다.</div></div>
                  </div>
                  <div className="column blue">
                    <div className="title">도입 후</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon06.png" alt=""/></div>실시간 얼굴 인식 출결과 학부모 알림 연동</div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 도입하고 나서 가장 크게 달라진 점은 무엇인가요?</div></div>
                    <div className="chat response"><div className="bubble blue">학생들이 학원에 들어오면 얼굴 인식으로 자동 출결이 기록되고, 학부모님께 실시간으로 알림이 전송됩니다. 별도의 카드나 앱 조작 없이 얼굴만 인식하면 되니, 
                      학생들도 편하고 출결 누락도 없어졌어요. 관리자는 모바일로 전체 출결 현황을 실시간으로 확인할 수 있어 매우 효율적입니다.</div></div>
                    <div className="chat user"><div className="bubble blue">학부모님들과 학생들의 반응은 어떤가요?</div></div>
                    <div className="chat response"><div className="bubble blue">학부모님들 반응이 좋습니다. "우리 아이가 언제 학원에 도착했는지 바로 알 수 있어서 안심된다"는 피드백이 많아요. 학생들도 얼굴만 인식하면 되니
                      재미있어하고, 출결 체크 시간이 줄어들어 수업 시작도 더 원활해졌습니다.</div></div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 고민하는 다른 학원에 한 말씀 해주신다면?</div></div>
                    <div className="chat response"><div className="bubble blue">학원 운영에서 가장 중요한 건 학생의 안전과 학부모의 신뢰라고 생각합니다. FACEONE은 이 두가지를 동시에 해결해주는 솔루션이에요. 
                      특히 출결 관리에 어려움을 겪는 학원이라면 꼭 도입해보시길 추천드립니다.</div></div>
                  </div>
                </div>
              </div>
              {/* <!--//도입사례--> */}
            </div>
          </div>  
        </section>
        {/* <!--//교육-->
        <!--건설--> */}
        <section className="bsn_wrap snlink" id="bsn_erect">
          <div className="container">
            <div className="bsn_content04">
              <div className="bsn_visual_text">
                <h2>"입주민을 위한 스마트 출입 시스템"</h2>
                <p>아파트, 오피스, 복합시설 등 다양한 건축물의 입주 후 공용시설 관리를 위해<br/>입주민 전용 출입통제 시스템과 HR운영 솔루션을 제공합니다.</p>
              </div>
              <div className="bsn_content_bg">
                <div className="bsn_tit">건설</div>
                <p className="bsn_bg_txt">입주민의 공용 시설 출입을 안전하고 편리하게 제어할 수 있습니다.
                  <br/>모바일·생체인증 기반 출입 시스템으로 커뮤니티 공간의 이용을 효율적으로 관리합니다.
                  <br/>건설 이후까지 이어지는 통합 관리 솔루션을 제공합니다.</p>
                <div className="bsn_bg_overlay"></div>
              </div>
              <div className="bsn_content_box bsn_content_txt">
                
                <div className="bsn_content_icon_wrap">
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content04_icon01.png" alt="공용 시설 출입 권한 설정"/></div>
                    <p className="tit">공용 시설 출입 권한 설정</p>
                    <p>피트니스, 회의실, 커뮤니티룸 등<br/>시설별 출입 조건 제어</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content04_icon02.png" alt="입주민 인증 방식 다양화"/></div>
                    <p className="tit">입주민 인증 방식 다양화</p>
                    <p>비밀번호, 카드, 모바일 앱,<br/>생체인식 등 방식 지원</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content04_icon03.png" alt="예약 기반 출입 통제"/></div>
                    <p className="tit">예약 기반 출입 통제</p>
                    <p>사전 예약 시에만 출입<br/>가능하도록 연동 설정</p>
                  </div>
                  <div className="bsn_content_icon">
                    <div className="icon"><img src="../assets/images/btn_content04_icon04.png" alt="출입기록 로그 자동 저장"/></div>
                    <p className="tit">출입기록 로그 자동 저장</p>
                    <p>이용자별 출입 기록 저장 및<br/>관리자 확인 기능</p>
                  </div>
                </div>
              </div>
              {/* <!--도입사례--> */}
              <div className="case_chat_wrap">
                <div className="case_chat_tit">
                  <div className="chat_txt01">FACEONE 모바일 서비스 도입 전후 인터뷰</div>
                  <div className="chat_txt02">OO건설 현장 안전관리팀 이정우 부장님</div>
                </div>
                <div className="case_chat_box aca">
                  <div className="column gray">
                    <div className="title">도입 전</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon01.png" alt=""/></div>외부 인력 출입 관리와 안전 통제의 어려움</div>
                    <div className="chat user"><div className="bubble gray">FACEONE 모바일 서비스를 도입하기 전, 어떤 점이 가장 불편하셨나요?</div></div>
                    <div className="chat response"><div className="bubble gray">건설 현장은 매일 수십 명의 외부 인력과 협력업체 직원들이 출입합니다. 기존에는 수기로 출입 명부를 작성하거나, 간단한 QR 인증을 사용했는데, 대리 출입이나 기록 누락이 자주 발생했어요. 특히 안전 교육 이수 여부나 출입 시간 확인이 어려워 사고 예방에 한계가 있었습니다.
                    </div></div>
                    <div className="chat user"><div className="bubble gray">기존 시스템의 한계는 무엇이었나요?</div></div>
                    <div className="chat response"><div className="bubble gray">출입 기록이 실시간으로 확인되지 않아, 현장 내 인원 파악이 늦어졌고, 비상 상황 시 대피 인원 확인도 어려웠습니다. 또한, 외부 인력의 신원 확인이 제대로 되지 않아 보안 사고 위험도 있었습니다.
                    </div></div>
                  </div>
                  <div className="column blue">
                    <div className="title">도입 후</div>
                    <div className="subtitle"><div className="chat_icon"><img src="../assets/images/chat_icon02.png" alt=""/></div>얼굴 인식 기반 출입 관리로 안전과 효율 향상</div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 도입하고 나서 가장 크게 달라진 점은 무엇인가요?</div></div>
                    <div className="chat response"><div className="bubble blue">이제는 현장에 들어오는 모든 인력이 얼굴 인식으로 출입을 인증합니다. 사전 등록만 하면 모바일 앱을 통해 자동으로 출입 기록이 남고, 관리자 앱에서 실시간으로 인원 현황을 확인할 수 있어요. 특히 안전 교육 이수 여부도 연동되어, 미이수자는 출입이 제한됩니다
                    </div></div>
                    <div className="chat user"><div className="bubble blue">현장 인력들의 반응은 어떤가요?</div></div>
                    <div className="chat response"><div className="bubble blue">처음엔 생소했지만, 지금은 “카드나 명부 없이 얼굴만 인식하면 되니 훨씬 편하다”는 반응이 많습니다. 출입 속도도 빨라지고, 대기 시간이 줄어들어 작업 시작이 더 원활해졌어요. 관리자 입장에서도 인원 통제가 훨씬 쉬워졌습니다.
                    </div></div>
                    <div className="chat user"><div className="bubble blue">FACEONE 모바일 서비스를 고민하는 다른 건설사에 한 말씀 해주신다면?</div></div>
                    <div className="chat response"><div className="bubble blue">건설 현장은 안전이 최우선입니다. FACEONE은 단순한 출입 인증을 넘어, 실시간 인원 관리와 안전 통제까지 가능하게 해주는 스마트 솔루션입니다. 특히 외부 인력이 많은 현장이라면 꼭 도입해보시길 추천드립니다.
                    </div></div>
                  </div>
                </div>
              </div>  
              {/* <!--//도입사례--> */}
            </div>
          </div>  
        </section>
        {/* <!--//건설--> */}

        {/* 무료 체험 */}
        <section className="sub_testimonials" data-aos="fade-up">
          <div className="container">
            <div className="experience_box" >
              <h3>인공지능과 혁신으로 더 안전하고 간편하게!<br />지금 무료로 체험해보세요.</h3>
              <button className="free_btn" onClick={navigateToContract}>무료체험하기</button>
            </div>
          </div>
        </section>
      </main>
     
    </>
  );
};

export default Business;
